<div class="ap-margin-bottom-2 ap-display-block">
    <h2>{{ getOpenAmountText() }}</h2>

    <div class="ap-margin-bottom-2 ap-display-block">
        <div class="ap-grid ap-grid-cols-12">
            <div class="ap-col-span-12 ap-col-span-gt-sm-4">
                <ap-amount-input
                    currency="€"
                    data-bb="bedrag"
                    fxFlex
                    [numberOfDecimals]="2"
                    [maxDigits]="9"
                    [formControl]="openAmountFormControl"
                    placeholder="0,00"
                >
                </ap-amount-input>
            </div>
        </div>
    </div>

    <dl>
        <dt>{{ 'shared.nameAndIban.label' | apContent }}</dt>
        <dd>
            {{
                'shared.nameAndIban.value'
                    | apContent
                        : {
                              ontvanger: this.getWeergavenaam(this.betaalverzoek.crediteur)
                          }
            }}
            {{ betaalverzoek.crediteur.iban | apIban }}
        </dd>

        <dt>{{ 'shared.description.label' | apContent }}</dt>
        <dd>{{ betaalverzoek.omschrijving }}</dd>

        @if (betaalverzoek.verloopt_op) {
            <dt>{{ 'shared.expires.label' | apContent }}</dt>
        }
        @if (betaalverzoek.verloopt_op) {
            <dd>
                {{
                    'shared.expires.value'
                        | apContent
                            : {
                                  datum: betaalverzoek.verloopt_op | date: 'dd-MM-yyyy',
                                  tijdstip: betaalverzoek.verloopt_op | date: 'HH:mm'
                              }
                }}
            </dd>
        }
    </dl>
</div>
